import { render } from "./Department.vue?vue&type=template&id=e2ca4f0c&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=e2ca4f0c&lang=scss&scoped=true"
import "./Department.vue?vue&type=style&index=1&id=e2ca4f0c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2ca4f0c"]])

export default __exports__